import React from "react";

export const Section = ({ dark, className = "", children }) => (
  <section className={`py-16 md:py-20 ${dark ? "rq-greendark" : "rq-light"} ${className}`}>
    <div className="rq-container">{children}</div>
  </section>
);

export const Paragraph = ({ children, className = "" }) => (
  <p className={`mt-4 text-[15px] md:text-[17px] leading-[1.85] text-[color:var(--rq-muted)] ${className}`}>
    {children}
  </p>
);

export const Kicker = ({ children }) => (
  <span className="rq-tag">
    <span className="h-px w-6 bg-[color:var(--rq-green)] inline-block" />
    {children}
  </span>
);

export const CardNodes = ({ nodes, small }) =>
  nodes.map((n, ni) =>
    n.t === "h4" ? (
      <h4 key={ni} className="font-display mt-4 text-[15px] font-semibold text-[color:var(--rq-green)]">
        {n.v}
      </h4>
    ) : n.t === "p" ? (
      <p key={ni} className={`mt-3 ${small ? "text-sm" : "text-[15px]"} leading-relaxed text-[color:var(--rq-muted)]`}>
        {n.v}
      </p>
    ) : null
  );
